import { useLocalForageState } from '../../../common/reactQuery/hooks/useLocalForageState';

import { StockTabs } from '../../stockConstants';

import { StockCache } from '../../StockCache';

const initialScale = 240;

interface ThreeDStockContentScaleOptions {
  tab: StockTabs;
}

function useThreeDStockContentScale({ tab }: ThreeDStockContentScaleOptions) {
  const { value: scale, setValue: setScale } = useLocalForageState<number>(
    StockCache.scaleCacheKey(tab),
    initialScale
  );

  return {
    scale: scale ?? initialScale,
    setScale
  };
}

export default useThreeDStockContentScale;
